import { useEffect, useState } from "react";
import {
  IPortfoPairPositionUser,
  IRolePairPositionTableReport,
} from "../../../Interfaces/deltaHedgeAccounts";
import { DropdownItem } from "../../../Interfaces/dropdownInterfaces";
import { IGetOrdersDTO } from "../../../Interfaces/optionDomain";
import { getOrders } from "../../../Requests/optionDomain";
import { getStepInstruments } from "../../../Requests/stepRequests";
import { INLegsAddOrderFormValues } from "../../../Interfaces/nLegsInterfaces";
import { packetErrorHandler } from "../../../Utils/requestUtils";
import { addNLegOrder } from "../../../Requests/nLegsRequests";
import { toast } from "react-toastify";
import SahraConnections from "../../../Pages/Sahra/SahraConnections";
import Button from "../../../Components/Button";
import NLegOrderPreviewTable from "./NLegOrderPreviewTable";
import Form from "../../../Components/Form";
import Modal from "../../../Components/Modal/Modal";
import DynamicMultiSelectDropdown from "../../../Components/Dropdown/DynamicMultiSelectDropdown";
import { getDeltaHedgeAccountsDropdown } from "../../../Requests/deltaHedgeAccounts";
import TextInput from "../../../Components/TextInput";
import StaticDropdown from "../../../Components/Dropdown/StaticDropdown";
import { StaticMultiSelectDropdown } from "../../../Components/Dropdown/StaticMultiSelectDropdown";
import { StepOptionOrderType } from "../../../Interfaces/stepInterfaces";

interface IProps {
  row: IRolePairPositionTableReport;
  onAction: () => void;
}

enum ModalMode {
  Closed,
  SahraOrderTable,
  OrderPreview,
}

const SendRequestConfig = ({ row, onAction }: IProps) => {
  const [formValues, setFormValues] = useState({
    price: parseFloat(row.priceValue?.replaceAll(",", "")),
    ratio2: row.hedgeFactor?.replaceAll(",", ""),
    ratio1: "1",
    instrumentId1: row.instrumentId1,
    instrumentId2: row.instrumentId2,
    instrumentName1: row.instrumentName1,
    instrumentName2: row.instrumentName2,
    involvedFund: row.involvedFund?.replaceAll(",", ""),
    contractSize1: row.contractSize1?.replaceAll(",", ""),
    contractSize2: row.contractSize2?.replaceAll(",", ""),
    orderSide1: row.orderSide1Enum,
    orderSide2: row.orderSide2Enum,
    accountIds: row.users?.map((u) => parseInt(u.userId)),
  } as IGetOrdersDTO);

  const [instrumentOptions, setInstrumentOptions] = useState(
    [] as DropdownItem[]
  );
  const [modalMode, setModalMode] = useState(ModalMode.Closed);
  const [loading, setLoading] = useState(false);
  const [orders, setOrders] = useState([] as INLegsAddOrderFormValues[]);

  useEffect(() => {
    getStepInstruments()
      .then((resp) => {
        setInstrumentOptions(resp);
      })
      .catch(packetErrorHandler);
  }, []);

  const changeHandler = (name: string, value: any) => {
    setFormValues({ ...formValues, [name]: value });
  };

  function getUniqueUsers() {
    const users: IPortfoPairPositionUser[] = [];
    if (!row.users || !row.users.length) return [];
    row.users.forEach((u) => {
      if (!users.find((user) => user.userId === u.userId?.toString()))
        users.push({ ...u, userId: u.userId?.toString() });
    });
    return users;
  }

  const submitHandler = () => {
    setLoading(true);
    getOrders(formValues)
      .then((resp) => {
        const hedgeFactor = parseFloat(row.hedgeFactor?.replaceAll(",", ""));

        setOrders(
          resp.map((order) => ({
            ...order,
            uNLegsItems: [
              {
                orderSide: row.orderSide1Enum,
                contractSize: row.contractSize1?.replaceAll(",", "") as any,
                instrumentId: row.instrumentId1,
                ratio: 1
                 ,
                volume: Math.abs(
                  row.offsetSide === 1
                    ? getUniqueUsers().find(
                        (user) => user.userId === order.userId?.toString()
                      )?.relatedPortfo.instrumentVolume1 || 0
                    : (getUniqueUsers().find(
                        (user) => user.userId === order.userId?.toString()
                      )?.relatedPortfo.instrumentVolume2 || 0) / hedgeFactor
                ),
                optionOrderType:
                  row.offsetSide === 1
                    ? StepOptionOrderType.Offset
                    : StepOptionOrderType.Open,
              },
              {
                orderSide: row.orderSide2Enum,
                contractSize: row.contractSize2?.replaceAll(",", "") as any,
                instrumentId: row.instrumentId2,
                ratio: hedgeFactor,
                volume: Math.abs(
                  row.offsetSide === 2
                    ? getUniqueUsers().find(
                        (user) => user.userId === order.userId?.toString()
                      )?.relatedPortfo.instrumentVolume2 || 0
                    : (getUniqueUsers().find(
                        (user) => user.userId === order.userId?.toString()
                      )?.relatedPortfo.instrumentVolume1 || 0) * hedgeFactor
                ),
                optionOrderType:
                  row.offsetSide === 2
                    ? StepOptionOrderType.Offset
                    : StepOptionOrderType.Open,
              },
            ],
          }))
        );
        setModalMode(ModalMode.OrderPreview);
      })
      .catch(packetErrorHandler)
      .finally(() => setLoading(false));
  };
  const sendNlegOrders = () => {
    const requests = orders.map((order) =>
      addNLegOrder({
        ...order,
        uNLegsItems: order.uNLegsItems.map((i) => ({
          ...i,
        })),
      })
    );
    setLoading(true);
    Promise.all(requests)
      .then(() => {
        toast.success("با موفقیت انجام شد");
        onAction();
        setModalMode(ModalMode.Closed);
      })
      .catch(packetErrorHandler)
      .finally(() => setLoading(false));
  };

  const sahraUserTableModalUI = (
    <div className="flex flex-col justify-start items-center gap-3">
      <SahraConnections
        initialSearchParam={{
          userIds: formValues.accountIds,
        }}
      />

      <div className="w-[100px] mr-auto">
        <Button text="ثبت" variant="contained" onClick={sendNlegOrders} />
      </div>
    </div>
  );

  const orderPreviewModalUI = (
    <div className="flex flex-col justify-start items-center gap-3">
      <NLegOrderPreviewTable values={orders} offsetSide={row.offsetSide} />

      <div className="w-[100px] mr-auto">
        <Button
          text="ثبت"
          variant="contained"
          onClick={() => setModalMode(ModalMode.SahraOrderTable)}
        />
      </div>
    </div>
  );

  const getModalMode = () => {
    switch (modalMode) {
      case ModalMode.Closed:
        return <></>;

      case ModalMode.SahraOrderTable:
        return sahraUserTableModalUI;

      case ModalMode.OrderPreview:
        return orderPreviewModalUI;

      default:
        return <></>;
    }
  };

  return (
    <Form className="!w-80 gap-3 p-2 px-2 !mx-auto">
      {modalMode !== ModalMode.Closed ? (
        <Modal
          onClose={() => setModalMode(ModalMode.Closed)}
          UI={getModalMode()}
        />
      ) : (
        <></>
      )}
      <StaticMultiSelectDropdown
        name="accountIds"
        label="اکانت ها"
        extraLabel={true}
        value={formValues.accountIds}
        onChange={changeHandler}
        items={row.users?.map((u) => ({ id: u.userId, name: u.userName }))}
        withSelectAll
      />
      <TextInput
        label="نسبت"
        value={`1 : ${row.hedgeFactor}`}
        name=""
        onChange={() => {}}
        disabled
        extraLabel
      />
      <StaticDropdown
        onChange={changeHandler}
        dropdown={{
          name: "",
          placeholder: `نماد جهت اول (${
            row.offsetSide === 1 ? "Offset" : "Open"
          })`,
          disabled: true,
          extraLabel: true,
        }}
        value={row.instrumentId1}
        options={instrumentOptions}
      />
      <StaticDropdown
        onChange={changeHandler}
        dropdown={{
          name: "",
          placeholder: `نماد جهت اول (${
            row.offsetSide === 2 ? "Offset" : "Open"
          })`,
          disabled: true,
          extraLabel: true,
        }}
        value={row.instrumentId2}
        options={instrumentOptions}
      />
      <TextInput
        label="حداکثر بهای تمام شده"
        value={formValues.price?.toString()}
        name="price"
        onChange={changeHandler}
        extraLabel
      />

      <Button text="ثبت" variant="contained" onClick={submitHandler} />
    </Form>
  );
};

export default SendRequestConfig;
